import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGtFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53400)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.6672 41.3788H0.862598C0.386524 41.3788 0.000488281 40.9928 0.000488281 40.5167V9.48223C0.000488281 9.00615 0.386524 8.62012 0.862598 8.62012H16.6672V41.3788Z",
					fill: "#82AFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.3345 8.62061H16.6675V41.3794H33.3345V8.62061Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1381 41.3792H33.3335V8.62061H49.1381C49.6142 8.62061 50.0002 9.00664 50.0002 9.48271V40.5172C50.0002 40.9934 49.6142 41.3792 49.1381 41.3792Z",
					fill: "#82AFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.7829 20.7134L24.2886 20.9606L24.7434 21.1483L24.7829 20.7134Z",
					fill: "#FFC855"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0008 29.8488C22.2532 29.8488 20.0181 27.6135 20.0181 24.8661C20.0181 23.1593 20.8771 21.5899 22.316 20.668L22.4439 20.8678C21.0734 21.746 20.2554 23.2407 20.2554 24.8661C20.2554 27.4828 22.3843 29.6116 25.0009 29.6116L25.0008 29.8488Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.1489 30.1597C22.3388 30.1984 22.6316 30.1483 22.9324 30.0082C23.2333 29.868 23.46 29.676 23.5524 29.5058C23.3626 29.4671 23.0697 29.5172 22.7689 29.6573C22.4683 29.7976 22.2415 29.9895 22.1489 30.1597Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5532 29.5056C23.5919 29.3157 23.5418 29.0229 23.4018 28.7221C23.2615 28.4212 23.0696 28.1945 22.8993 28.1021C22.8607 28.2919 22.9108 28.5848 23.0508 28.8855C23.1909 29.1861 23.3829 29.4129 23.5532 29.5056Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.1562 29.5505C21.3384 29.6167 21.6354 29.61 21.9535 29.5157C22.2716 29.4213 22.5241 29.2645 22.6406 29.1097C22.4585 29.0435 22.1614 29.0502 21.8434 29.1445C21.5253 29.2389 21.2728 29.3956 21.1562 29.5505Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.6408 29.1094C22.707 28.9272 22.7004 28.6302 22.606 28.3121C22.5115 27.9939 22.3549 27.7415 22.2001 27.625C22.1339 27.8071 22.1405 28.1042 22.2348 28.4223C22.3293 28.7404 22.486 28.993 22.6408 29.1094Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.2378 28.7195C20.4051 28.8173 20.6984 28.8643 21.0284 28.8285C21.3584 28.7928 21.6349 28.6839 21.7772 28.5526C21.61 28.4548 21.3166 28.4078 20.9866 28.4436C20.6566 28.4793 20.3802 28.5882 20.2378 28.7195Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7776 28.5521C21.8754 28.3849 21.9224 28.0915 21.8866 27.7615C21.8509 27.4315 21.742 27.1551 21.6107 27.0127C21.5129 27.18 21.4659 27.4733 21.5017 27.8033C21.5374 28.1333 21.6463 28.4099 21.7776 28.5521Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.479 27.5722C19.6263 27.6981 19.9067 27.7963 20.2378 27.8194C20.5688 27.8426 20.8604 27.7844 21.0236 27.6804C20.8764 27.5546 20.5959 27.4564 20.2648 27.4333C19.9338 27.4101 19.6424 27.4682 19.479 27.5722Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.0234 27.6804C21.1493 27.5331 21.2475 27.2526 21.2706 26.9216C21.2938 26.5905 21.2357 26.299 21.1317 26.1357C21.0058 26.283 20.9076 26.5635 20.8845 26.8945C20.8612 27.2257 20.9193 27.517 21.0234 27.6804Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.0347 26.3081C19.1522 26.4621 19.4057 26.6171 19.7245 26.7094C20.0434 26.8017 20.3403 26.8061 20.5221 26.7388C20.4045 26.5848 20.1511 26.4298 19.8322 26.3375C19.5134 26.2452 19.2163 26.2406 19.0347 26.3081Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5224 26.7389C20.6764 26.6213 20.8314 26.3679 20.9236 26.049C21.016 25.7302 21.0204 25.4332 20.953 25.2515C20.799 25.369 20.6441 25.6225 20.5518 25.9413C20.4595 26.2603 20.4551 26.5571 20.5224 26.7389Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.8467 24.8326C18.9207 25.0117 19.1258 25.2266 19.4102 25.3979C19.6945 25.569 19.9804 25.6498 20.1733 25.6313C20.0993 25.4522 19.8942 25.2374 19.6099 25.0661C19.3256 24.8949 19.0396 24.8144 18.8467 24.8326Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1735 25.6314C20.3526 25.5573 20.5674 25.3522 20.7387 25.0679C20.9099 24.7835 20.9907 24.4977 20.9722 24.3047C20.7931 24.3787 20.5783 24.5838 20.407 24.8682C20.2359 25.1526 20.155 25.4385 20.1735 25.6314Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.0249 23.439C19.0597 23.6296 19.2152 23.8827 19.4573 24.1098C19.6994 24.3368 19.9622 24.4756 20.1545 24.4981C20.1197 24.3075 19.9642 24.0544 19.7221 23.8273C19.48 23.6004 19.2174 23.4614 19.0249 23.439Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1548 24.4982C20.3454 24.4635 20.5985 24.3079 20.8256 24.0658C21.0526 23.8237 21.1914 23.5609 21.214 23.3687C21.0233 23.4034 20.7702 23.559 20.5432 23.8011C20.3161 24.0431 20.1771 24.3057 20.1548 24.4982Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.7249 21.9316C19.6851 22.1212 19.7332 22.4144 19.8715 22.7161C20.0098 23.0179 20.2004 23.2457 20.37 23.3394C20.4099 23.1498 20.3617 22.8566 20.2235 22.5549C20.0852 22.253 19.8946 22.0251 19.7249 21.9316Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.3701 23.3393C20.5597 23.3791 20.8528 23.331 21.1546 23.1927C21.4563 23.0544 21.6842 22.8638 21.7778 22.6942C21.5883 22.6543 21.2951 22.7025 20.9934 22.8408C20.6916 22.979 20.4637 23.1697 20.3701 23.3393Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5619 20.8149C20.4726 20.9868 20.4402 21.2822 20.4922 21.61C20.5443 21.9378 20.6665 22.2086 20.8048 22.3442C20.8942 22.1724 20.9266 21.877 20.8745 21.5492C20.8225 21.2215 20.7001 20.9507 20.5619 20.8149Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.8047 22.3444C20.9766 22.4337 21.272 22.4661 21.5997 22.4141C21.9275 22.362 22.1983 22.2398 22.334 22.1015C22.1621 22.0121 21.8667 21.9797 21.539 22.0318C21.2111 22.0838 20.9403 22.2061 20.8047 22.3444Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3824 20.0381C21.2688 20.195 21.1932 20.4822 21.1964 20.8142C21.1996 21.1461 21.2808 21.4318 21.3975 21.5864C21.5111 21.4295 21.5867 21.1423 21.5835 20.8104C21.5803 20.4785 21.4992 20.1926 21.3824 20.0381Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3975 21.5864C21.5544 21.7001 21.8416 21.7757 22.1735 21.7725C22.5055 21.7692 22.7912 21.6881 22.9458 21.5714C22.7889 21.4577 22.5017 21.3821 22.1697 21.3854C21.8379 21.3886 21.5521 21.4698 21.3975 21.5864Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7959 21.1796C21.989 21.1952 22.2738 21.1105 22.5557 20.9352C22.8376 20.76 23.0396 20.5423 23.1111 20.3622C22.9181 20.3466 22.6332 20.4312 22.3514 20.6065C22.0695 20.7816 21.8675 20.9994 21.7959 21.1796Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0005 29.8489V29.6116C27.6171 29.6116 29.746 27.4828 29.746 24.8661C29.746 23.2407 28.9278 21.7459 27.5574 20.8678L27.6854 20.668C29.1242 21.5899 29.9833 23.1594 29.9833 24.8661C29.9832 27.6135 27.748 29.8489 25.0005 29.8489Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.8522 30.1597C27.6624 30.1984 27.3695 30.1483 27.0687 30.0082C26.7679 29.868 26.5412 29.676 26.4487 29.5058C26.6386 29.4671 26.9314 29.5172 27.2322 29.6573C27.5329 29.7976 27.7597 29.9895 27.8522 30.1597Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4487 29.5056C26.41 29.3157 26.4601 29.0229 26.6001 28.7221C26.7404 28.4212 26.9323 28.1945 27.1026 28.1021C27.1412 28.2919 27.0911 28.5848 26.9511 28.8855C26.811 29.1861 26.619 29.4129 26.4487 29.5056Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.8452 29.5505C28.6631 29.6167 28.366 29.61 28.048 29.5157C27.7299 29.4213 27.4773 29.2645 27.3608 29.1097C27.543 29.0435 27.84 29.0502 28.1581 29.1445C28.4762 29.2389 28.7287 29.3956 28.8452 29.5505Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.3607 29.1094C27.2946 28.9272 27.3011 28.6302 27.3954 28.3121C27.49 27.9939 27.6466 27.7415 27.8014 27.625C27.8676 27.8071 27.861 28.1042 27.7666 28.4223C27.6723 28.7404 27.5156 28.993 27.3607 29.1094Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.7631 28.7195C29.5958 28.8173 29.3024 28.8643 28.9725 28.8285C28.6425 28.7928 28.366 28.6839 28.2236 28.5526C28.3909 28.4548 28.6843 28.4078 29.0143 28.4436C29.3442 28.4793 29.6207 28.5882 29.7631 28.7195Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.2239 28.5521C28.1262 28.3849 28.0792 28.0915 28.115 27.7615C28.1507 27.4315 28.2596 27.1551 28.3909 27.0127C28.4887 27.18 28.5357 27.4733 28.4999 27.8033C28.4642 28.1333 28.3553 28.4099 28.2239 28.5521Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.5227 27.5722C30.3754 27.6981 30.0949 27.7963 29.7639 27.8194C29.4328 27.8426 29.1414 27.7844 28.978 27.6804C29.1253 27.5546 29.4058 27.4564 29.7368 27.4333C30.0679 27.4101 30.3593 27.4682 30.5227 27.5722Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.9773 27.6804C28.8514 27.5331 28.7533 27.2526 28.7301 26.9216C28.707 26.5905 28.7651 26.299 28.8691 26.1357C28.995 26.283 29.0931 26.5635 29.1163 26.8945C29.1395 27.2257 29.0814 27.517 28.9773 27.6804Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.9669 26.3081C30.8493 26.4621 30.5959 26.6171 30.2771 26.7094C29.9583 26.8018 29.6612 26.8061 29.4795 26.7388C29.5971 26.5848 29.8505 26.4298 30.1693 26.3375C30.4882 26.2452 30.7853 26.2406 30.9669 26.3081Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4795 26.7389C29.3255 26.6213 29.1705 26.3679 29.0782 26.049C28.9858 25.7302 28.9814 25.4332 29.0488 25.2515C29.2028 25.369 29.3578 25.6225 29.4501 25.9413C29.5424 26.2603 29.5468 26.5571 29.4795 26.7389Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.1548 24.8326C31.0808 25.0117 30.8757 25.2266 30.5913 25.3979C30.3069 25.569 30.0211 25.6498 29.8281 25.6313C29.9021 25.4522 30.1072 25.2374 30.3916 25.0661C30.6759 24.8949 30.9619 24.8144 31.1548 24.8326Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.8282 25.6314C29.6491 25.5573 29.4342 25.3522 29.2629 25.0679C29.0917 24.7835 29.011 24.4977 29.0294 24.3047C29.2085 24.3787 29.4234 24.5838 29.5947 24.8682C29.766 25.1526 29.8466 25.4385 29.8282 25.6314Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.9763 23.439C30.9415 23.6296 30.7859 23.8827 30.5438 24.1098C30.3018 24.3368 30.039 24.4756 29.8467 24.4981C29.8814 24.3075 30.037 24.0544 30.2791 23.8273C30.5212 23.6003 30.7838 23.4614 30.9763 23.439Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.8468 24.4982C29.6561 24.4635 29.403 24.3079 29.176 24.0658C28.9489 23.8237 28.8102 23.5609 28.7876 23.3687C28.9782 23.4034 29.2313 23.559 29.4584 23.8011C29.6854 24.0431 29.8244 24.3057 29.8468 24.4982Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.2768 21.9316C30.3166 22.1212 30.2685 22.4144 30.1302 22.7161C29.9919 23.0179 29.8013 23.2457 29.6317 23.3394C29.5918 23.1498 29.64 22.8566 29.7783 22.5549C29.9165 22.253 30.1072 22.0251 30.2768 21.9316Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.6313 23.3393C29.4418 23.3791 29.1486 23.331 28.8469 23.1927C28.5451 23.0544 28.3173 22.8638 28.2236 22.6942C28.4132 22.6543 28.7063 22.7025 29.0081 22.8408C29.3099 22.979 29.5378 23.1697 29.6313 23.3393Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4396 20.8149C29.5289 20.9868 29.5614 21.2822 29.5093 21.61C29.4573 21.9378 29.335 22.2086 29.1967 22.3442C29.1074 22.1724 29.0749 21.877 29.127 21.5492C29.179 21.2215 29.3014 20.9507 29.4396 20.8149Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.1968 22.3444C29.0249 22.4337 28.7295 22.4661 28.4018 22.4141C28.0739 22.362 27.8031 22.2398 27.6675 22.1015C27.8394 22.0121 28.1348 21.9797 28.4625 22.0318C28.7903 22.0838 29.0611 22.2061 29.1968 22.3444Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6187 20.0381C28.7323 20.195 28.8079 20.4822 28.8047 20.8142C28.8015 21.1461 28.7203 21.4318 28.6036 21.5864C28.4899 21.4295 28.4144 21.1423 28.4176 20.8104C28.4208 20.4785 28.5019 20.1926 28.6187 20.0381Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6035 21.5864C28.4466 21.7001 28.1594 21.7757 27.8274 21.7725C27.4955 21.7692 27.2098 21.6881 27.0552 21.5714C27.2121 21.4577 27.4993 21.3821 27.8312 21.3854C28.1632 21.3886 28.4488 21.4698 28.6035 21.5864Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.2054 21.1796C28.0123 21.1952 27.7274 21.1105 27.4456 20.9352C27.1637 20.76 26.9616 20.5423 26.8901 20.3622C27.0832 20.3466 27.3681 20.4312 27.6499 20.6065C27.9317 20.7816 28.1338 20.9994 28.2054 21.1796Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.2803 28.7449L21.4166 29.6086L20.9907 28.7567L22.2685 27.479L22.6943 27.9049L22.5713 28.2739C22.5121 28.4515 22.4125 28.6127 22.2803 28.7449Z",
					fill: "#966446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9531 22.3687L22.2684 27.0534C22.1508 27.171 22.1508 27.3617 22.2684 27.4793L22.4813 27.6922L23.3331 26.8403L26.7402 23.0072L27.1661 22.5813L26.9531 22.3687Z",
					fill: "#B9B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4213 26.3264C23.3648 26.3828 23.333 26.4595 23.333 26.5393V26.8404L26.7401 23.0073L23.4213 26.3264Z",
					fill: "#966446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.1661 22.5814L26.9532 22.3686L26.7402 22.5814L26.9532 22.7945L27.1661 23.0075L29.5086 20.2393L27.1661 22.5814Z",
					fill: "#A0A0A0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.958 28.7449L28.8217 29.6086L29.2476 28.7567L27.9698 27.479L27.5439 27.9049L27.667 28.2739C27.7262 28.4515 27.8258 28.6127 27.958 28.7449Z",
					fill: "#966446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.2853 22.3687L27.97 27.0534C28.0876 27.171 28.0876 27.3617 27.97 27.4793L27.7571 27.6922L26.9053 26.8403L23.4981 23.0072L23.0723 22.5813L23.2853 22.3687Z",
					fill: "#B9B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.8169 26.3264C26.8733 26.3828 26.9052 26.4595 26.9052 26.5393V26.8404L23.498 23.0073L26.8169 26.3264Z",
					fill: "#966446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.072 22.5814L23.2849 22.3686L23.4979 22.5814L23.2849 22.7945L23.072 23.0075L20.7295 20.2393L23.072 22.5814Z",
					fill: "#A0A0A0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.3711 28.5677L23.5827 28.7606C24.3548 27.9142 25.7059 26.4328 27.8477 24.5098C27.8478 24.5099 26.0733 25.6052 23.3711 28.5677Z",
					fill: "#B9B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.7721 29.4368C22.6962 29.3674 22.6908 29.2497 22.76 29.1737L23.2135 28.6764C23.2829 28.6005 23.4006 28.5951 23.4766 28.6643C23.5526 28.7337 23.558 28.8514 23.4887 28.9274L23.0352 29.4247C22.9659 29.5008 22.8481 29.5062 22.7721 29.4368Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1991 28.4111L23.0763 28.4659C22.967 28.5203 22.6795 28.6829 22.63 28.9146C22.6063 29.0244 22.6396 29.1313 22.7249 29.2325C22.733 29.2116 22.744 29.1913 22.7601 29.1738L22.8173 29.1112C22.7787 29.0552 22.7582 29.0001 22.7698 28.9448C22.8009 28.7999 22.9942 28.6705 23.1157 28.6063L23.6591 29.102L23.7942 28.9538L23.1991 28.4111Z",
					fill: "#FFC855"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.8652 28.802L26.6536 28.995C25.8815 28.1485 24.5305 26.6672 22.3887 24.7441C22.3886 24.7442 24.163 25.8394 26.8652 28.802Z",
					fill: "#B9B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.4639 29.6712C27.5399 29.6018 27.5453 29.484 27.476 29.4081L27.0225 28.9108C26.9532 28.8348 26.8354 28.8295 26.7594 28.8987C26.6835 28.968 26.6781 29.0858 26.7473 29.1618L27.2008 29.659C27.2702 29.7351 27.388 29.7405 27.4639 29.6712Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.0365 28.6455L27.1594 28.7003C27.2687 28.7547 27.5562 28.9173 27.6057 29.149C27.6293 29.2588 27.596 29.3657 27.5107 29.4669C27.5026 29.446 27.4916 29.4258 27.4755 29.4082L27.4184 29.3456C27.4569 29.2895 27.4774 29.2345 27.4658 29.1792C27.4348 29.0343 27.2414 28.9049 27.1199 28.8407L26.5766 29.3363L26.4414 29.1882L27.0365 28.6455Z",
					fill: "#FFC855"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2115 20.965C25.2281 20.9238 25.2378 20.8792 25.2378 20.832C25.2378 20.6354 25.0784 20.4761 24.8818 20.4761C24.6853 20.4761 24.5259 20.6354 24.5259 20.832C24.5259 20.9491 24.5832 21.0521 24.6706 21.1171C24.5419 22.1508 25.5611 22.2298 25.9495 22.3743C26.5388 22.5935 27.2779 23.0371 27.2314 24.2771C27.1863 25.4823 26.4241 26.6453 26.4241 26.6453L27.0568 25.7852C26.8255 26.7637 26.2853 28.0102 25.0005 29.4925C25.0005 29.4925 25.8789 28.6332 26.6119 27.5251C26.0726 28.7939 25.475 29.967 25.475 29.967C25.475 29.967 26.5329 28.5928 27.3881 26.2151C28.4248 23.3325 26.2439 21.6007 25.2115 20.965Z",
					fill: "#69B469"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.2899 25.2212H23.3408V25.6958H24.2899V25.2212Z",
					fill: "#F4E08F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.3398 26.1709C23.602 26.1709 23.8145 25.9584 23.8145 25.6963C23.8145 25.4342 23.602 25.2217 23.3398 25.2217C23.0777 25.2217 22.8652 25.4342 22.8652 25.6963C22.8652 25.9584 23.0777 26.1709 23.3398 26.1709Z",
					fill: "#ECD077"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.3403 23.0869C23.6025 23.0869 23.8149 22.8744 23.8149 22.6123C23.8149 22.3502 23.6025 22.1377 23.3403 22.1377C23.0782 22.1377 22.8657 22.3502 22.8657 22.6123C22.8657 22.8744 23.0782 23.0869 23.3403 23.0869Z",
					fill: "#ECD077"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.1871 23.0864C26.4492 23.0864 26.6617 22.8739 26.6617 22.6118C26.6617 22.3497 26.4492 22.1372 26.1871 22.1372H23.3398C23.602 22.1372 23.8145 22.3497 23.8145 22.6118C23.8145 22.8739 23.602 23.0864 23.3398 23.0864C23.0777 23.0864 22.8652 22.8739 22.8652 22.6118C22.8652 23.4084 23.5318 24.3715 23.7468 25.2219C23.7468 25.2219 23.8144 25.4344 23.8144 25.6965C23.8144 25.9586 23.6019 26.1711 23.3397 26.1711H26.187C26.4491 26.1711 26.6616 25.9586 26.6616 25.6965C26.6616 24.8999 25.995 23.9368 25.7801 23.0864H26.1871Z",
					fill: "#FCF0A8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8149 22.6118C23.8149 22.8739 23.6024 23.0864 23.3403 23.0864H26.1876C26.4497 23.0864 26.6622 22.8739 26.6622 22.6118H23.8149Z",
					fill: "#F4E08F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8145 25.6963C23.8145 25.9584 23.602 26.1709 23.3398 26.1709H26.1871C26.4492 26.1709 26.6617 25.9584 26.6617 25.6963H23.8145Z",
					fill: "#F4E08F"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53400",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGtFlag);
export { ForwardRef as ReactComponent };
